const initialState = {
  detail: {tokenList:[]},
  fetchSwapPending:false
};

export default initialState;
